export interface ApiGetHistoryAsyncStatusListRequest {
    task_ids: string;
}

export interface ApiGetHistoryAsyncStatusItemResponse {
    async_status: string;
    is_read: boolean;
    task_id: string;
    task_type: string;
    title: string;
    type: string;
    updated_at: string;
}


export const GetHistoryAsyncStatusList = Symbol('GetHistoryAsyncStatusList');

export interface GetHistoryAsyncStatusList {
    getHistoryAsyncStatusList(data: ApiGetHistoryAsyncStatusListRequest): Promise<ApiGetHistoryAsyncStatusItemResponse[]>;
}